// extracted by mini-css-extract-plugin
module.exports = {"contentBoard":"styles_contentBoard__2nhih"};